// import gsap from 'gsap'
import { addStaticSplideClasses, bp, callAfterResize, dev, l, mm, onDOMAndFontsReady, preventOrphan, sel, selAll, stResizeObserver, wrapLastTwo } from './utils'
// import { SplitText } from 'gsap/SplitText'
// import SplitType from 'split-type'
// import SplitType from 'split-type'
// import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Splide from '@splidejs/splide'
import '@splidejs/splide/css'

import './home.css'
import { VidstackPlayer, VidstackPlayerLayout } from 'vidstack/global/player'
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll'

gsap.registerPlugin(ScrollTrigger)
// gsap.registerPlugin(SplitText, ScrollTrigger)

export default function Home() {
  // console.log('Home 1105 loaded')
  // return
  if (!dev) {
    window.addEventListener('load', function () {
      document.fonts.load('1rem "DM Sans"').then(() => {
        pageInit()
      })
    })
  } else {
    pageInit()
  }
  mm.add(bp.tabUp, () => {
    stResizeObserver()
  })
  function pageInit() {
    console.log('Home 1105 init')
    const isDeskSafari = !!(window.safari && window.safari.pushNotification)
    const ifChromeBlur = !isDeskSafari ? { filter: 'blur(50px)' } : {}

    mm.add(bp.tabUp, () => {
      // return
      const alert$ = sel('.alert')
      const hero$ = sel('.hero.is--v2')
      // if (!alert$ || !hero$) return
      let reduceHeight = alert$.offsetHeight || 0
      const stickyNavbar$ = sel('.navbar-sticky')
      if (stickyNavbar$) {
        const navbarHeight = stickyNavbar$.offsetHeight
        reduceHeight += navbarHeight
      }
      hero$.style.minHeight = `calc(100vh - ${reduceHeight}px)`

      const testSec$ = sel('.testimonial-slider-sec')
      // gsap.set(testSec$, { y: -window.innerHeight + reduceHeight })
      // console.log('hero$', testSec$)
      const introTl = gsap.timeline({ defaults: { ease: 'none', duration: 2 } })
      //
      // .from(testSec$, { y: '100%' }, 0)
      // ScrollTrigger.create({
      //   trigger: hero$,
      //   start: 'bottom bottom',
      //   end: `bottom top+=${reduceHeight}`,
      //   // markers: true,
      //   scrub: true,
      //   pin: testSec$,
      //   pinSpacing: false,
      //   // triggerActions: 'play none none reverse',
      //   animation: introTl,
      // })
    })
    // Logos
    function logosInit() {
      const slider$ = sel('.logos__slider')
      if (!slider$) return

      addStaticSplideClasses(slider$)
      const slider = new Splide(slider$, {
        arrows: false,
        pagination: false,
        // type: 'fade',
        gap: '4rem',
        autoWidth: true,
        drag: 'free',
        // perPage: 1,
        type: 'loop',
        clones: 10,
        // speed: 4000,
        // interval: 1000,
        // autoplay: dev ? false : true,
        easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
        dragMinThreshold: {
          mouse: 50,
          touch: 50,
        },
        autoScroll: {
          speed: -0.25,
        },
        breakpoints: {
          768: {
            // speed: 1000,
            // easing: 'ease-out',
          },
        },
        // drag: false,
      }).mount({ AutoScroll })
    }
    logosInit()
    // Props sec
    const prop$a = selAll('.epic-props__item')
    prop$a.forEach((prop$) => {
      // console.log(prop$)
      const p$a = prop$.querySelectorAll('.p--epic')
      const pW$ = prop$.querySelector('.p-w--epic')
      const pWa$ = pW$.sel('a')
      const pWSt = SplitText.create(pW$, { type: 'words', wordsClass: 'word' })
      const propTl = gsap
        .timeline({ defaults: { duration: 1, ease: 'none' } })
        //
        .fromTo(
          pWSt.words,
          {
            autoAlpha: 0.2,
          },
          {
            autoAlpha: 1,
            stagger: { amount: 5 },
          }
        )

      ScrollTrigger.create({
        trigger: prop$,
        start: 'top bottom',
        end: 'bottom 75%',
        scrub: true,
        animation: propTl,
        // markers: true,
      })
    })

    // Video bg section
    const propSec$ = sel('.epic-props-sec')
    const introSec$ = sel('.epic-intro-sec')
    const intro$ = sel('.epic-intro-sec')
    const introBg$ = sel('.epic-intro__bg-w')
    const introDim$ = sel('.epic-intro__dim-top')
    const introBlend$ = sel('.epic-intro__dim')
    const introVidBg$ = sel('.epic-intro__vid-bg-w')
    const introH$ = intro$.querySelector('h2')
    const introHsT = SplitText.create(introH$, { type: 'chars, words' })

    gsap.set(introSec$, { y: '-100%' })
    const introTl = gsap
      .timeline({ defaults: { ease: 'none', duration: 2 } })
      .from(introDim$, { autoAlpha: 1, duration: 7 }, 0)
      .from(introVidBg$, { scale: 1.2, duration: 7 }, 0)
    // .from(intro$, { marginBottom: '-100vh' }, 5)

    ScrollTrigger.create({
      trigger: propSec$,
      start: 'bottom bottom',
      end: 'bottom top',
      scrub: true,
      pin: intro$,
      pinSpacing: false,
      // triggerActions: 'play none none reverse',
      animation: introTl,
    })

    ScrollTrigger.create({
      trigger: propSec$,
      start: 'bottom 99%',
      toggleActions: 'play none none reverse',
      // markers: true,
      animation: gsap.from(introHsT.chars, {
        autoAlpha: 0,
        // filter: 'blur(50px)',
        ...ifChromeBlur,
        stagger: {
          each: 0.006,
        },
        duration: 0.8,
      }),
    })

    async function videoModal() {
      const videoBtn$ = sel('#customPlayerBtn')

      const sec$ = sel('.epic-test-sec')
      const _modW$ = sec$?.querySelector('.mod-w')
      if (!videoBtn$ || !_modW$) return console.log('no video btn')
      const modW$ = sel('body').appendChild(_modW$)

      const close$ = modW$.querySelector('.mod__x-w')
      const mod$ = modW$.querySelector('.mod')
      const bg$ = modW$.querySelector('.mod-bg')

      const _player = modW$.querySelector('.custom_player.is--test')
      // console.log(_player.getAttribute('src'))
      const src = _player.getAttribute('data-src') || 'youtube/4UgnVc7kRxE'
      const player = await VidstackPlayer.create({
        target: _player,
        src: src,
        // src: 'vimeo/1061484821',
        // poster:
        // 'https://cdn.prod.website-files.com/655b9a852f3d2a5de3c90048/6826898440714274aa9fd120_67575b133690ca3c5bb9254a_test_img1_q85-gigapixel-low%20resolution%20v2-4x%20copy.webp',
        crossOrigin: true,
        playsInline: true,
        viewType: 'video',
        load: 'idle',
        layout: new VidstackPlayerLayout(),
      })
      gsap.set(modW$, { autoAlpha: 0 })
      modW$.classList.add('display-hide')
      // console.log('player ready', modW$)
      const tl = gsap
        .timeline({ defaults: { duration: 1, ease: 'power4.inOut' }, paused: true })
        .to(modW$, { autoAlpha: 1 })
        .from(mod$, { y: 50 }, 0)
      tl.eventCallback('onReverseComplete', () => {
        modW$.classList.add('display-hide')
      })

      tl.eventCallback('onStart', () => {
        modW$.classList.remove('display-hide')
      })

      const closeModal = (e) => {
        e?.stopImmediatePropagation()
        tl.reverse()
        player.pause()
      }

      videoBtn$.onclick = (e) => {
        // console.log('pl', player.state.canPlay)
        tl.play()

        if (player.state.canPlay) {
          player.play()
        } else {
          player.addEventListener(
            'can-play',
            (event) => {
              // console.log('canplay')
              player.play()
            },
            { once: true }
          )
        }
      }
      ;[close$, bg$].forEach((el) => {
        el.onclick = closeModal
      })

      player.addEventListener('ended', (event) => {
        closeModal()
      })

      callAfterResize(() => closeModal())
      // console.log('videoBtn$', videoBtn$)
    }
    videoModal()
    mm.add(bp.tabUp, () => {
      // Footer

      const cta$ = sel('.epic-cta-sec')
      const ctaH$ = cta$.querySelector('h2')
      const ctaHsT$ = SplitText.create(ctaH$, { type: 'words, chars' })
      const ctaP$ = cta$.querySelector('.epic-cta__info>div:not(.button-group)')
      const ctaBtnGroup$ = cta$.sel('.button-group')
      const ctaBtn$a = ctaBtnGroup$.selAll('.btn')
      const ctaBgSvg$ = cta$.querySelector('.epic-cta__bg-w.is--svg')
      const ctaBgWebp$ = cta$.querySelector('.epic-cta__bg-w-w.is--webp')
      const footer$ = sel('.footer')
      // console.log(ctaBgSvg$, ctaBgWebp$)
      if (isDeskSafari) {
        ctaBgSvg$.style.display = 'none'
        ctaBgWebp$.style.display = 'block'
      }
      const ctaTl = gsap
        .timeline({ defaults: { ease: 'power3.out', duration: 1 } })
        //
        .from(
          ctaHsT$.chars,
          {
            autoAlpha: 0,
            // filter: 'blur(50px)',
            ...ifChromeBlur,
            stagger: 0.03,
            ease: 'none',
          },
          0
        )
        .from(ctaP$, { autoAlpha: 0, y: -20 }, '<50%')
        .from(ctaBtn$a, { autoAlpha: 0, y: -20 }, '<10%')
        .from(footer$, { y: 20, autoAlpha: 0, duration: 3 }, '<10%')

      ScrollTrigger.create({
        trigger: cta$,
        start: 'top 80%',
        // end: '+=100%',
        // scrub: true,
        animation: ctaTl,
        toggleActions: 'play none none reverse',
      })
    })
  }
}
